module.exports = __webpack_public_path__ + "static/media/ivan3.928126d9.jpg";